import React, { useMemo, useRef } from "react";
import { useInView } from "react-intersection-observer";
import Section from "./Section";
import LeftArrowSVG from "./SVG/LeftArrowSVG";
import RightArrowSVG from "./SVG/RightArrowSVG";
import {
  greenHomeOutterRenderPaths,
  innerRenderPaths,
} from "../assest/imgPaths";
import image1 from "../assest/Nikea/images/image1.jpeg";
import image2 from "../assest/Nikea/images/image2.jpeg";
import image3 from "../assest/Nikea/images/image3.jpeg";
import image4 from "../assest/Nikea/images/image4.jpeg";
import image5 from "../assest/Nikea/images/image5.jpeg";
import image6 from "../assest/Nikea/images/image6.jpeg";
import nikeaHerro from "../assest/Nikea/images/NikeaHerroImg.jpeg";

const images = [
  innerRenderPaths[1],
  innerRenderPaths[2],
  innerRenderPaths[3],
  innerRenderPaths[4],
  innerRenderPaths[5],
  innerRenderPaths[6],
  innerRenderPaths[7],
  innerRenderPaths[8],
  innerRenderPaths[9],
  innerRenderPaths[10],
  innerRenderPaths[11],
  innerRenderPaths[12],
];

const PhotoGallery = ({ project }) => {
  const { inView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  const scrollContainerRef = useRef(null);

  const handleScroll = (direction) => {
    const scrollAmount = 1000; // Amount to scroll
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };
  const unitedImages = useMemo(() => {
    let outterImgs = [];
    if (project === "greenHome") {
      outterImgs = [
        greenHomeOutterRenderPaths.dark,
        greenHomeOutterRenderPaths.light,
        greenHomeOutterRenderPaths.photo1,
        greenHomeOutterRenderPaths.photo2,
        greenHomeOutterRenderPaths.roadView,
      ];
    } else if (project === "nikea") {
      outterImgs = [image1, image2, image3, image4, image5, image6, nikeaHerro];
    }
    return [...outterImgs, ...images];
  }, [project]);

  return (
    <Section>
      <div className="col-span-10 col-start-2">
        <h2 className="text-primary-bg-blue font-gilroy text-2xl lg:text-5xl tracking-widest w-full py-12 leading-snug lg:leading-relaxed">
          K2 ავტომშენებელზე - ინფრასტრუქტურა
        </h2>
        <div className="col-span-11 h-[2px] bg-black opacity-30 " />
        <div className="col-span-11 relative">
          <button
            onClick={() => handleScroll("left")}
            className="hidden absolute left-12 top-1/2 transform -translate-y-1/2 bg-primary-light text-primary-orange border-2 hover:border-primary-orange p-2 rounded-full z-10  transition rotate-180 xl:flex items-center justify-center"
          >
            <LeftArrowSVG size={24} />
          </button>
          <div
            ref={scrollContainerRef}
            className={`flex items-center gap-4 py-12 ${
              inView ? "fade-in" : ""
            } overflow-x-auto xl:overflow-hidden snap-x snap-mandatory scroll-smooth scrollbar-hide`}
          >
            {unitedImages.map((url, index) => (
              <div
                key={index}
                className="hover:scale-110 rounded-xl transition-transform duration-500  h-56 w-64 max-w-full bg-black flex-shrink-0 flex flex-col items-center gap-4 text-primary-dark snap-center"
              >
                <img
                  src={url}
                  alt={`Gallery ${index + 1}`}
                  className="h-full w-full object-cover hover:opacity-80 rounded-xl"
                />
              </div>
            ))}
          </div>
          <button
            onClick={() => handleScroll("right")}
            className=" hidden absolute right-12 top-1/2 transform -translate-y-1/2 bg-primary-light text-primary-orange border-2 hover:border-primary-orange p-2 rounded-full z-10  transition xl:flex items-center justify-center"
          >
            <RightArrowSVG size={24} />
          </button>
        </div>
      </div>
    </Section>
  );
};

export default PhotoGallery;
